import './scripts/current';
import './scripts/mobileMenu';
import './scripts/newsCardFromStorage';
import './scripts/favoriteBlock';
import './scripts/themeFavorite';
import './scripts/themeFavoriteMobile';
import './scripts/searchNewsfromFavoriteStorage';
